{
  "greeting": "Hallo! Hoe kan ik u vandaag helpen met wijn?",
  "thinking": "✨ Nadenken...",
  "thinkingStep": "✨ De perfecte match voor u ontkurken…🍷",
  "askAboutWine": "Bijv. 1990's Bordeaux rood rond $1500 | Bourgogne dorps wit onder $600",
  "askAboutWineFirst": "Ik wil kopen (regio + kleur + jaargang + budget)",
  "waitingForResponse": "Wachten op antwoord...",
  "dailyLimitReached": "U heeft de dagelijkse advieslimiet bereikt. Kom na 00:00 HKT terug om door te gaan.",
  "chatHistory": "Uw chatgeschiedenis",
  "noChatHistory": "Nog geen chatgeschiedenis",
  "startConversation": "Start een gesprek om het hier te zien",
  "backToChat": "Terug naar chat",
  "newChat": "Nieuwe chat",
  "history": "Geschiedenis",
  "search": "Zoeken",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "Wijnadviseur",
  "chat": "Chat",
  "chatNumber": "Chat {number}",
  "wineRecommended": "{count} wijn aanbevolen",
  "winesRecommended": "{count} wijnen aanbevolen",
  "justNow": "Zojuist",
  "minuteAgo": "{count} minuut geleden",
  "minutesAgo": "{count} minuten geleden",
  "hourAgo": "{count} uur geleden",
  "hoursAgo": "{count} uur geleden",
  "dayAgo": "{count} dag geleden",
  "daysAgo": "{count} dagen geleden",
  "noMessagesYet": "Nog geen berichten",
  "perBottle": "Per fles",
  "priceNA": "Prijs niet beschikbaar",
  "buyNow": "Nu kopen",
  "moreInformation": "Meer informatie",
  "share": {
    "button": "Delen",
    "title": "Gesprek delen",
    "description": "Deel dit gesprek met uw vrienden via de onderstaande link:",
    "generating": "Deellink genereren...",
    "error": "Kon deellink niet genereren",
    "copy": "Kopiëren",
    "copied": "Gekopieerd!",
    "note": "Opmerking: Deze link verloopt over 30 dagen. Wanneer iemand deze link opent, ziet hij een kopie van dit gesprek."
  },
  "checkOutWine": "Bekijk deze wijn: {name} {vintage}",
  "linkCopied": "Link gekopieerd naar klembord!",
  "contactWhatsApp": "Neem contact met ons op via WhatsApp voor meer opties",
  "errorLoadingWine": "Sorry, ik kon de wijndetails niet laden.",
  "errorOccurred": "Er is een fout opgetreden bij het ophalen van het antwoord.",
  "you": "U",
  "welcome": {
    "intro": "Welkom bij WWX, ik ben Zyra, uw AI-wijnadviseur. U heeft toegang tot:",
    "features": {
      "globalMarket": "Wereldwijde fijne wijnmarkt (UK, FR, HK verkopers)",
      "realTimeOffers": "Realtime beste aanbiedingen binnen uw budget",
      "personalized": "Gepersonaliseerde aanbevelingen speciaal voor u",
      "comparison": "Eenvoudige vergelijking van jaargangen en merken",
      "instantCheckout": "Direct hoeveelheden en verzending afrekenen"
    },
    "question": "Wat kan ik u vandaag aanbevelen?",
    "trendingPrompts": "Voorbeeldvragen",
    "promptExamples": {
      "title": "Hoe te vragen:",
      "good": "✓ Goede voorbeelden:",
      "bad": "✗ Vermijd vragen zonder budget:"
    },
    "prompts": {
      "bordeaux": "Bordeaux rood rond $800",
      "champagne": "Grower champagne onder $2000",
      "firstGrowth": "Beste aanbieding first growth 2010-2019"
    }
  },
  "feedback": {
    "helpful": "Dit was nuttig",
    "notHelpful": "Dit was niet nuttig",
    "thankYou": "Bedankt voor uw feedback!",
    "whatDidYouLike": "Wat vond u goed?",
    "whatCouldBeImproved": "Wat kan er verbeterd worden?",
    "category": "Categorie",
    "selectCategory": "Selecteer een categorie",
    "categories": {
      "accuracy": "Nauwkeurigheid",
      "helpfulness": "Behulpzaamheid",
      "responseSpeed": "Reactiesnelheid",
      "clarity": "Duidelijkheid",
      "other": "Overig"
    },
    "comments": "Opmerkingen",
    "placeholder": "Vertel ons meer over uw ervaring...",
    "cancel": "Annuleren",
    "submit": "Feedback verzenden",
    "submitting": "Verzenden..."
  },
  "auth": {
    "limitReached": "Dagelijkse limiet bereikt",
    "signUpToday": "Meld u aan voor meer berichten",
    "limitMessage": "U heeft uw dagelijkse berichtlimiet bereikt. Maak een gratis account aan om door te chatten.",
    "benefitsMessage": "Maak een gratis account aan om door te chatten en uw chatgeschiedenis op al uw apparaten op te slaan.",
    "remainingMessages": "U heeft vandaag nog {count} berichten over",
    "signUp": "Aanmelden",
    "login": "Inloggen",
    "loggedInAs": "Ingelogd als {email}",
    "logout": "Uitloggen"
  }
}
